import {
  PAYMENTS_CARD_BEGIN,
  PAYMENTS_CARD_SUCCESS,
  PAYMENTS_CARD_FAILURE
} from 'actions/payments';

const initialState = {
  items: [],
  pageCount: 50,
  pageNumber: 1,
  loading: false,
  error: false,
};

export default function payments(state = initialState, action) {
  switch (action.type) {
    case PAYMENTS_CARD_BEGIN:
      return { ...state, loading: true };
    case PAYMENTS_CARD_SUCCESS:
      return {
        ...state,
        items: [...state.items, ...action.payload.payments],
        pageCount: action.payload.pageCount,
        pageNumber: action.payload.pageNumber,
        loading: false,
        error: false,
      };
    case PAYMENTS_CARD_FAILURE:
      return { ...state, error: action.error, loading: false };
    default:
      return state;
  }
}
